var dataTable_directive = require('./lib/DataTable');
var defaultSorter_directive = require('./lib/DefaultSorter');
var paginator_component = require('./lib/Paginator');
var bootstrapPaginator_component = require('./lib/BootstrapPaginator');
var dataTable_module = require('./lib/DataTableModule');

exports.DataTable = dataTable_directive.DataTable;
exports.DataEvent = dataTable_directive.DataEvent;
exports.PageEvent = dataTable_directive.PageEvent;
exports.SortEvent = dataTable_directive.SortEvent;
exports.DefaultSorter = defaultSorter_directive.DefaultSorter;
exports.Paginator = paginator_component.Paginator;
exports.BootstrapPaginator = bootstrapPaginator_component.BootstrapPaginator;
exports.DataTableModule = dataTable_module.DataTableModule;



//////////////////
// WEBPACK FOOTER
// ./~/angular2-datatable/index.js
// module id = 768
// module chunks = 16